import Vue from 'vue';
import $ from 'jquery';
import Flickity from 'flickity';


/* Vue components */
import { PhotoSwipe, PhotoSwipeGallery } from 'v-photoswipe';

var app = new Vue({
    el: '#app',
    components: {
        'v-photoswipe': PhotoSwipe,
    },
    data: {
        nav: nav,
        drawer: false,
        photoswipe: {
            isOpen: false,
            isOpenGallery: false,
            options: {
                index: 0
            },
            optionsGallery: {},
            items: media,
        }
    },
    methods: {
        isNavActive: function (origin, current) {
            if (this.nav[origin] === null && origin === current)
            {
                this.nav[origin] = true;
            }
            return this.nav[origin];
        },
        showPhotoSwipe: function (index) {
            this.photoswipe.isOpen = true
            this.$set(this.photoswipe.options, 'index', index)
        },
        hidePhotoSwipe: function () {
            this.photoswipe.isOpen = false
        }
    }
});